module.exports = __webpack_public_path__ + "img/202109-group.4fb74e62.jpg";